export const adaptModalidadProfesionalCobro = (modalidadProfesionalData) => {
    return {
        id: modalidadProfesionalData?.idModalidadProfesionalCobro,
        displayName: modalidadProfesionalData?.nombre,
    }
}

export const adaptModalidadProfesionalCobroArray = (
    modalidadProfesionalCobro
) => {
    return structuredClone(modalidadProfesionalCobro?.allModalidadProfesionalCobro)
        ?.map(modalidadProfesional => adaptModalidadProfesionalCobro(modalidadProfesional));
}